import { css } from "styled-system/css";
import { token } from "styled-system/tokens";

export type SignalStrength = "none" | "low" | "okay" | "good" | "excellent";

export interface ConnectionIndicatorProps {
  signal: SignalStrength;
}

export const ConnectionIndicator = ({ signal }: ConnectionIndicatorProps) => {
  return (
    // The bars show the signal only by colour; `data-signal` exposes it.
    <div
      className={css({ bg: "background.canvas", textStyle: "body.md" })}
      data-testid="connection-indicator"
      data-signal={signal}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect x="1" y="12" width="2" height="2" fill={getBarColor(signal, 0)} />
        <rect x="4" y="10" width="2" height="4" fill={getBarColor(signal, 1)} />
        <rect x="7" y="8" width="2" height="6" fill={getBarColor(signal, 2)} />
        <rect x="10" y="5" width="2" height="9" fill={getBarColor(signal, 3)} />
        <rect x="13" y="2" width="2" height="12" fill={getBarColor(signal, 4)} />
      </svg>
    </div>
  );
};

const getBarColor = (signal: SignalStrength, barIndex: number) => {
  const green = token("colors.text.positive");
  const defaultColor = token("colors.background.secondary");

  switch (signal) {
    case "none":
      return defaultColor;
    case "low":
      if ([0, 1].includes(barIndex)) return green;
      return defaultColor;
    case "okay":
      if ([0, 1, 2].includes(barIndex)) return green;
      return defaultColor;
    case "good":
      if ([0, 1, 2, 3].includes(barIndex)) return green;
      return defaultColor;
    case "excellent":
      return green;
  }
};
